import { motion } from "framer-motion";
import { SEO } from "@/components/SEO";

export default function TermsPage() {
  return (
    <div className="min-h-screen pt-20" data-testid="terms-page">
      <SEO
        title="Terms of Service"
        description="Jersey Girls Terms of Service. Review our membership agreement terms, facility rules, cancellation policies, and liability information. Last updated January 2026."
        url="/terms"
        type="article"
      />
      <section className="py-12 md:py-20 px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-heading font-black text-white mb-8" data-testid="terms-heading">
              TERMS OF SERVICE
            </h1>
            
            <div className="prose max-w-none">
              <p className="text-gray-700 mb-8">
                Last updated: January 2026
              </p>

              <div className="space-y-8 text-gray-700">
                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Acceptance of Terms</h2>
                  <p className="text-gray-700">
                    By accessing or using Jersey Girls facilities and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Membership Agreement</h2>
                  <p className="mb-4 text-gray-700">
                    Your membership is subject to the specific terms outlined in your membership agreement, including:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Payment terms and billing cycles</li>
                    <li>Cancellation policies and notice requirements</li>
                    <li>Facility access and usage rules</li>
                    <li>Guest policies</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Facility Rules</h2>
                  <p className="mb-4 text-gray-700">
                    While using our facilities, you agree to:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Follow all posted rules and staff instructions</li>
                    <li>Use equipment properly and safely</li>
                    <li>Respect other members and staff</li>
                    <li>Maintain appropriate attire and hygiene</li>
                    <li>Not engage in illegal or harmful activities</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Assumption of Risk</h2>
                  <p className="text-gray-700">
                    You acknowledge that physical exercise involves inherent risks. You assume full responsibility for any injuries or damages that may occur during your use of our facilities. We recommend consulting a physician before beginning any exercise program.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Limitation of Liability</h2>
                  <p className="text-gray-700">
                    Jersey Girls shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from your use of our facilities or services, except where prohibited by law.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Cancellation Policy</h2>
                  <p className="text-gray-700">
                    Membership cancellations must be submitted in accordance with your membership agreement. Please note that certain memberships may require advance notice or be subject to early termination fees.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Modifications</h2>
                  <p className="text-gray-700">
                    Jersey Girls reserves the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">Contact Information</h2>
                  <p className="text-gray-700">
                    For questions about these Terms of Service, please contact us at:<br />
                    Email: contact@giantfitnessclubs.com<br />
                    Phone: (856) 382-0555
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
